module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Notifications#1-afb8eeaa606b3e5201e27c6dadb1d305.svg";